import {
    SHOW_ACCESSORY_MAPPING_UPLOAD_DIALOG,
    HIDE_ACCESSORY_MAPPING_UPLOAD_DIALOG,
} from "../actions/types";

const INITIAL_STATE = {
    accessoryMappingUploadDialog: {
        entity: null,
        open: false
    }
}

const accessoryMappingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SHOW_ACCESSORY_MAPPING_UPLOAD_DIALOG:
            return {
                ...state,
                accessoryMappingUploadDialog: {
                    entity: action.payload.entity,
                    open: true
                }
            }
            case HIDE_ACCESSORY_MAPPING_UPLOAD_DIALOG:
                return {
                    ...state,
                    accessoryMappingUploadDialog: {
                        entity: null,
                        open: false,
                    }
                }
        default:
            return state;
    }
}

export default accessoryMappingReducer;